import axios from 'axios';
import ImportantNotificationDialogActionTypes from './important-notification-dialog-action-types';

export const loadImportantNotification = () => async(dispatch, getState, { api }) => {
  dispatch({ type: ImportantNotificationDialogActionTypes.LOAD_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_START });
  try {
    const state = getState().importantNotificationDialog;
    state.notificationCancelToken?.cancel();
    state.notificationCancelToken = axios.CancelToken.source();
    const notification = await api.get(`api/users/current/notifications/important`, null, state.notificationCancelToken.token);
    dispatch({
      type: ImportantNotificationDialogActionTypes.LOAD_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_END,
      payload: {
        notification: notification
      }
    });
    if (notification) {
      dispatch(openImportantNotificationDialog());
    }
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      throw error;
    }
  }
};

export const openImportantNotificationDialog = (payload) => async(dispatch) => {
  dispatch({
    type: ImportantNotificationDialogActionTypes.OPEN_IMPORTANT_NOTIFICATION_DIALOG,
    payload: payload
  });
};

export const closeImportantNotificationDialog = (payload) => async(dispatch) => {
  dispatch({
    type: ImportantNotificationDialogActionTypes.CLOSE_IMPORTANT_NOTIFICATION_DIALOG,
    payload: payload
  });
};

export const updateImportantNotificationConfirm = (payload) => async(dispatch, getState, { api }) => {
  if (getState().app.isUserImpersonated) {
    dispatch(closeImportantNotificationDialog());
    return;
  } else {
    dispatch({
      type: ImportantNotificationDialogActionTypes.UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_CONFIRM_START
    });
  }
  const { notificationId } = payload;
  try {
    await api.post(`api/users/current/notifications/${notificationId}/confirm`, null);
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      throw error;
    }
  } finally {
    dispatch(closeImportantNotificationDialog());
    dispatch(updateImportantNotificationRead(payload));
    dispatch({
      type: ImportantNotificationDialogActionTypes.UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_CONFIRM_END
    });
  }
};

export const updateImportantNotificationRead = (payload) => async(dispatch, getState, { api }) => {
  if (getState().app.isUserImpersonated) {
    dispatch(closeImportantNotificationDialog());
    return;
  } else {
    dispatch({
      type: ImportantNotificationDialogActionTypes.UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_READ_START
    });
  }
  const { notificationId } = payload;
  try {
    await api.post(`api/users/current/notifications/${notificationId}/read`, null);
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      throw error;
    }
  } finally {
    dispatch(closeImportantNotificationDialog());
    dispatch({
      type: ImportantNotificationDialogActionTypes.UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_READ_END
    });
  }
};
